import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { STYLES_INCENTIVES_TITLES, STYLES_INCENTIVES_ORDER } from 'site-modules/shared/constants/incentives';
import { StylesIncentivesLink } from './styles-incentives-link';

import './styles-incentives.scss';

export function StylesIncentivesMobile({ styles = [], mmy, link, onIncentiveClick }) {
  return (
    <section className="styles-incentives medium mt-1_5 mb-2" data-tracking-parent="incentive_grid">
      <h2 className="heading-3 mb-0">All {mmy} Deals</h2>
      {styles.map(style => (
        <Row key={style.id} className="py-1_5 align-items-center size-16 text-info row-separator" noGutters>
          <Col xs={12}>{style.name}</Col>
          <Col xs={12}>
            {STYLES_INCENTIVES_ORDER.map(incentiveType => (
              <Row className="py-0_5" key={incentiveType}>
                <Col xs={3} className="fw-bold">
                  {STYLES_INCENTIVES_TITLES[incentiveType]}
                </Col>
                <Col xs={9}>
                  <StylesIncentivesLink incentiveType={incentiveType} onClick={onIncentiveClick} style={style} />
                </Col>
              </Row>
            ))}
          </Col>
          <Col xs={12} className="pt-1">
            <Button
              tag="a"
              href={link}
              size="sm"
              color="outline-primary-b size-16"
              data-tracking-id="view_search_result"
              data-tracking-value="see_all_for_sale"
            >
              See all for sale
            </Button>
          </Col>
        </Row>
      ))}
    </section>
  );
}

StylesIncentivesMobile.propTypes = {
  styles: VehicleEntities.Styles,
  link: PropTypes.string.isRequired,
  mmy: PropTypes.string.isRequired,
  onIncentiveClick: PropTypes.func.isRequired,
};
